/**
 * Checks whether the quota of the user is exhausted or not.
 * @param {Object} profile Profile Object of the user
 * @returns true/false
 */
export const quotaExhausted = (profile) =>{
  return (profile.uniqueVisitorsQoutaLeft < 0  && (profile.plan.name === 'Free Forever Plan' || profile.plan?.id === 'price_HJBaYjGF19qCRO'))
}